import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth, useUser } from '@clerk/clerk-react';
import { CLIENTS_URL } from '../utils/constants';

// Importa el Layout
import Layout from '../Layout';
import NotFound from '../pages/NotFound';

const isDevBypass = () =>
  process.env.REACT_APP_DEV_BYPASS === 'true' ||
  localStorage.getItem('devBypass') === 'true';

const ProtectedRoute = ({
  component: Component,
  requiresAdminDomain = false,
  blockOnAdlerLocalDomain = false,
  ...rest
}) => {
  const { isSignedIn, isLoaded } = useAuth();
  const { user, isLoaded: userLoaded } = useUser();

  // Dev bypass — skip all auth checks
  if (isDevBypass()) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    );
  }

  // Mientras se carga la autenticación
  if (!isLoaded || (requiresAdminDomain && !userLoaded)) {
    return <div></div>;
  }

  // Verificar si el usuario tiene dominio @samxlabs.com o @adlerlocal.com
  const userEmail = user?.primaryEmailAddress?.emailAddress || '';
  const hasSamxlabsDomain =
    userEmail.endsWith('@samxlabs.com') ||
    userEmail.endsWith('@adlerlocal.com') ||
    userEmail.endsWith('@adlersocial.com');

  // Si la ruta requiere dominio @samxlabs.com
  if (requiresAdminDomain) {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (!isSignedIn) {
            return (
              <Redirect
                to={{
                  pathname: '/sign-in',
                  state: { from: props.location }
                }}
              />
            );
          }

          if (!hasSamxlabsDomain) {
            return <NotFound />;
          }

          return (
            <Layout>
              <Component {...props} />
            </Layout>
          );
        }}
      />
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isSignedIn ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect
            to={{
              pathname: '/sign-in',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
